/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
    <path d="M21 7.58643V6.08643C21 5.55599 20.7893 5.04728 20.4142 4.67221C20.0391 4.29714 19.5304 4.08643 19 4.08643H5C4.46957 4.08643 3.96086 4.29714 3.58579 4.67221C3.21071 5.04728 3 5.55599 3 6.08643V20.0864C3 20.6169 3.21071 21.1256 3.58579 21.5006C3.96086 21.8757 4.46957 22.0864 5 22.0864H8.5M16 2.08643V6.08643M8 2.08643V6.08643M3 10.0864H8M17.5 17.5864L16 16.3864V14.0864M22 16.0864C22 19.4001 19.3137 22.0864 16 22.0864C12.6863 22.0864 10 19.4001 10 16.0864C10 12.7727 12.6863 10.0864 16 10.0864C19.3137 10.0864 22 12.7727 22 16.0864Z" stroke="#262626" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
